import * as React from 'react'
import { useBulkActionLabels } from './useBulkActionLabels'
import {
  BulkActionsFooter,
  BulkActionsLabel,
  BulkActionsProps,
  SelectedRowCount,
} from '@user/components/xGrid'

export const LeadBulkActionFooter: React.FC<BulkActionsProps> = ({
  selectedRows,
}) => {
  const { avgAge, totalValue } = useBulkActionLabels(selectedRows)

  return (
    <BulkActionsFooter>
      <SelectedRowCount count={selectedRows.size} />
      <BulkActionsLabel label={avgAge} />
      <BulkActionsLabel label={totalValue} />
    </BulkActionsFooter>
  )
}
LeadBulkActionFooter.displayName = 'LeadBulkActionFooter'
